module.exports = __webpack_public_path__ + "static/media/marketplace_films.dfd32423.svg";